export const logicalSort = (a, b, direction) => {
  if (typeof a === 'string' && typeof b === 'string') {
    switch (direction) {
      case 'desc':
        return a.toLowerCase() > b.toLowerCase() ? -1 : 1;

      case 'asc':
        return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
      default:
        return 0;
    }
  } else {
    switch (direction) {
      case 'desc':
        return a > b ? -1 : 1;

      case 'asc':
        return a > b ? 1 : -1;
      default:
        return 0;
    }
  }
};
